import { observable, makeObservable } from "mobx";

export default class ObWaveformStore {
  liveMode = true;
  annotations = [];
  width;
  constructor(props) {
    makeObservable(this, {
      liveMode: observable,
      annotations: observable,
      width: observable,
    });

    Object.assign(this, props);
  }
  get chartLengthMs() {
    return this.summaryStore.endTime.diff(this.summaryStore.startTime);
  }
}
